function calcHypotenuse(a, b) {
  return Math.sqrt(a * a + b * b);
}

function vwToPx(vw) {
  const windowWidth = window.innerWidth;
  return (vw / 100) * windowWidth;
}

function pxToVw(px) {
  const viewportWidth = window.innerWidth;
  const heightInVw = (px / viewportWidth) * 100;
  return heightInVw;
}

function vhToPx(vh) {
  const windowHeight = window.innerHeight;
  return (vh / 100) * windowHeight;
}

function pxToVh(px) {
  const viewportHeight = window.innerHeight;
  const heightInVh = (px / viewportHeight) * 100;
  return heightInVh;
}

function vwToVh(vw) {
  const inPx = vwToPx(vw);
  return pxToVh(inPx);
}

function vhToVw(vh) {
  const inPx = vhToPx(vh);
  return pxToVw(inPx);
}

function calcVhMinusVw(vhValue, vwValue) {
  const vhInPx = (vhValue / 100) * window.innerHeight;
  const vwInPx = (vwValue / 100) * window.innerWidth;
  const resultPx = vhInPx - vwInPx;
  const resultVw = (resultPx / window.innerWidth) * 100;
  return resultPx;
}

const isDesktop = () => {
  return window.innerWidth >= 1278;
};

const isTablet = () => {
  return window.innerWidth >= 768;
};

function formatMoneyUSD(cents) {
  return '$' + (cents / 100).toFixed(2) + ' USD';
}

const getYouTubeID = (url) => {
  const regExp = /^.*(youtu\.be\/|v=|\/v\/|embed\/)([^#&?]*).*/;
  const match = url.match(regExp);
  return match && match[2].length === 11 ? match[2] : null;
};

function getCookie(name) {
  return document.cookie
    .split('; ')
    .find((row) => row.startsWith(name + '='))
    ?.split('=')[1];
}

function getTrueOffsetLeft(el) {
  let x = 0;
  let current = el;

  while (current) {
    const rect = current.getBoundingClientRect();
    x += rect.left;
    const style = window.getComputedStyle(current);
    const transform = style.transform;

    if (transform && transform !== 'none') {
      const match = transform.match(/matrix\(([^)]+)\)/);
      if (match) {
        const matrixValues = match[1].split(', ');
        x += parseFloat(matrixValues[4]);
      }
    }

    current = current.offsetParent;
  }

  return x;
}

const isExternalLink = (href) => {
  try {
    const linkUrl = new URL(href, window.location.href);
    return linkUrl.origin !== window.location.origin;
  } catch (e) {
    return false;
  }
};

const createPath = (path) => {
  const isInternational = window.location.href.includes('international');
  let addedPath = '';
  if(isInternational){
    addedPath = 'en-international';
  }
  return addedPath + path;
}

const runTasks = (tasks) => {
  let i = 0;

  const next = () => {
    if (i >= tasks.length) return;
    tasks[i++]();
    requestAnimationFrame(next);
  };

  next();
};

const addTweensByFrames = ({
  timeline,
  items,
  createTween,
  batchSize = 1,
  onComplete
}) => {
  let i = 0;

  const next = () => {
    let count = 0;

    while (i < items.length && count < batchSize) {
      createTween(items[i], i);
      i++;
      count++;
    }

    if (i < items.length) {
      requestAnimationFrame(next);
    } else {
      onComplete?.();
    }
  };

  next();
};


const addSectionObserver = (section, animationCallback, isMobileAdded = true, offset = '50%', runImmediately = true) => {
  if (!isDesktop()&& !isMobileAdded) return;

  const runWhenInView = () => {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animationCallback();
          obs.disconnect();
        }
      });
    }, {
      rootMargin: `0px 0px ${offset} 0px`,
      threshold: 0
    });
    observer.observe(section.get(0));
  };

  if (runImmediately && section.offset().top < window.innerHeight * 0.7) {
    animationCallback();
  } else {
    runWhenInView();
  }
}

const stopScroll = (e) => {
  e.preventDefault();
};

const nextFrame = () => {
  return new Promise(r => requestAnimationFrame(r));
}

const initEmblaControlsState = (emblaApi, prevBtn, nextBtn) => {
  const toggleNavBtnState = () => {
    if (emblaApi.canScrollPrev()) {
      prevBtn.prop('disabled', false);
    } else {
      prevBtn.prop('disabled', true);
    }

    if (emblaApi.canScrollNext()) {
      nextBtn.prop('disabled', false);
    } else {
      nextBtn.prop('disabled', true);
    }
  }

  toggleNavBtnState()

  emblaApi
    .on('select', toggleNavBtnState)
    .on('reinit', toggleNavBtnState)
}

const initEmblaControls = (emblaApi, prevBtn, nextBtn) => {
  const scrollPrev = () => {
    emblaApi.scrollPrev()
  }
  const scrollNext = () => {
    emblaApi.scrollNext()
  }
  prevBtn.on('click', scrollPrev)
  nextBtn.on('click', scrollNext)

  initEmblaControlsState(emblaApi, prevBtn, nextBtn)
}

const toggleDotsAnimation = (emblaApi, dotNodes) => {
  const previous = emblaApi.previousScrollSnap()
  const selected = emblaApi.selectedScrollSnap()
  gsap.to(dotNodes[previous].querySelectorAll('.slider-dot-inner'), {
    width: () => (isDesktop() ? '0.313vw' : isTablet() ? '0.651vw' : '1.389vw'),
    ease: 'tagInEasing',
    duration: 0.463,
  });
  gsap.to(dotNodes[selected].querySelectorAll('.slider-dot-inner'), {
    width: () => (isDesktop() ? '3vw' : isTablet() ? '6.25vw' : '13.333vw'),
    ease: 'tagInEasing',
    duration: 0.463,
  });
}

const addDotButtonAndClickHandlers = (emblaApi, dotsNode, toggleHandler) => {
  let dotNodes = []
  const addDotBtnsWithClickHandlers = () => {
    dotsNode.innerHTML = emblaApi
      .scrollSnapList()
      .map(() => '<button class="slider-dot embla__dot" type="button"><div class="slider-dot-inner"><div class="slider-dot-inner-progress"></div></div></button>')
      .join('')

    const scrollTo = (index) => {
      emblaApi.scrollTo(index)
    }

    dotNodes = Array.from(dotsNode.querySelectorAll('.embla__dot'))
    dotNodes.forEach((dotNode, index) => {
      dotNode.addEventListener('click', () => scrollTo(index), false)
    })
  }

  

  addDotBtnsWithClickHandlers()
  toggleHandler(emblaApi, dotNodes);

  emblaApi
    .on('reinit', addDotBtnsWithClickHandlers)
    .on('reinit', () => toggleHandler(emblaApi, dotNodes))
    .on('select', () => toggleHandler(emblaApi, dotNodes))
}

const addAutoplayProgressListeners = (emblaApi, progressNode, axis, additionalAnimation = () => {}) => {
  const progressBarNodes = progressNode.querySelectorAll('.slider-dot-inner-progress');

  let animationName = ''
  let timeoutId = 0
  let rafId = 0
  const progressBarTLs = [];

  const autoplay = emblaApi?.plugins()?.autoplay
  if (!autoplay) return

  const timeUntilNext = autoplay.timeUntilNext()
  if (timeUntilNext === null) return

  progressBarNodes.forEach(function(progressBarNode, index){
    if (axis == 'x'){
      progressBarTLs[index] = gsap.fromTo(progressBarNode, {
        width: '0%'
      },{
        width: '100%',
        duration: timeUntilNext / 1000,
        ease: 'linear',
        paused: true
      })
    } else if (axis == 'y') {
      progressBarTLs[index] = gsap.fromTo(progressBarNode, {
        height: '0%'
      },{
        height: '100%',
        duration: timeUntilNext / 1000,
        ease: 'linear',
        paused: true
      })
    }
  })
  additionalTL = additionalAnimation(timeUntilNext);

  const startProgress = (emblaApi) => {
    const selected = emblaApi.selectedScrollSnap();

    if(progressBarNodes[selected]){
      if (selected == 0) {
        progressBarTLs.forEach((tl => tl.progress(0).pause(0)));
      }
      progressBarTLs[selected].play(0)
      if(additionalTL != undefined){
        additionalTL[selected].play(0)
      }
    }
  }

  const stopProgress = (emblaApi) => {
    const selected = emblaApi.selectedScrollSnap();

    if(progressBarNodes[selected]){
      progressBarTLs[selected].progress(0)
      progressBarTLs[selected].pause()
      if(additionalTL != undefined){
        additionalTL[selected]?.progress(0)
        additionalTL[selected]?.pause()
      }
    }
  }

  startProgress(emblaApi);

  emblaApi
    .on('autoplay:timerset', startProgress)
    .on('autoplay:timerstopped', stopProgress)
}

const getReadingTime = (text, wordsPerMinute = 200) => {
  const words = text.trim().split(/\s+/).length;
  const minutes = Math.ceil(words / wordsPerMinute);
  return minutes;
}

function randomString(length = 6) {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);

  return Array.from(array, x => chars[x % chars.length]).join('');
}